export const VENDOR_FAQ_ITEMS = [
  {
    q: "What is PadPulse?",
    a: "PadPulse is a property management platform used by co-living hosts to coordinate maintenance, turnover cleaning, inspections, and other property work. When a host on PadPulse invites you as a vendor, you get access to this portal to manage your jobs with them.",
  },
  {
    q: "How are jobs assigned to me?",
    a: "A host creates a task and assigns it to you. You'll receive an SMS or email notification (based on your Profile → Notification Preferences). Open the portal, find the task in the Tasks tab, review the details, and accept it to confirm the job.",
  },
  {
    q: "How do I accept and complete a task?",
    a: "Go to the Tasks tab and tap the task card. Review the property address, instructions, and any attachments. Tap Accept to confirm the job. When the work is done, update the status to In Progress or Completed. You can also chat with the host directly from the task detail view.",
  },
  {
    q: "How does payment work?",
    a: "Hosts pay you through the PadPulse platform. To receive payments, connect your Stripe account under the Pay tab. Once connected, PadPulse will transfer your earnings (minus the 3% platform fee) to your Stripe account. You can choose standard (2–5 business days) or instant payout if your debit card supports it.",
  },
  {
    q: "What is the 3% platform fee?",
    a: "PadPulse charges a 3% fee on each side of the transaction. The host pays the job amount plus 3%, and you receive the job amount minus 3%. This fee covers payment processing, platform operations, and dispute protection.",
  },
  {
    q: "How do I connect my Stripe account for payouts?",
    a: "Go to the Pay tab and click 'Set up payouts.' You'll be guided through the Stripe Connect onboarding flow. You'll need to provide basic identity and banking information. Once approved, payouts will be automatic after each completed and approved job.",
  },
  {
    q: "How do I invite team members?",
    a: "As the account owner, go to the Team tab and click 'Invite Team Member.' Enter their name, phone number, and role (Member or Admin). They'll receive a text with a link to join. Members can view and work on tasks assigned to them; Admins have full access equivalent to the owner.",
  },
  {
    q: "How do I mute or change notification settings?",
    a: "Go to the Profile tab and scroll to Notification Preferences. You can toggle SMS and email alerts for task assignments, task messages, and form messages independently. Changes take effect immediately.",
  },
  {
    q: "How does the chat feature work on tasks and forms?",
    a: "You can message the host directly from a task or service form detail view. Open the task or form, scroll to the chat section, type your message, and tap Send. The host gets notified and can reply. All messages stay threaded with the relevant task or form so nothing gets lost.",
  },
  {
    q: "What are service forms?",
    a: "Service forms are structured checklists or inspection reports a host sends you to fill out on-site — for example, a move-in inspection or a punch list. Forms arrive as tasks in your Tasks feed — use the Forms filter to see just those. Open the task, complete each field, and submit when done.",
  },
  {
    q: "What does the Hosts tab show?",
    a: "The Hosts tab is your CRM — it lists every host you work with through PadPulse, along with their contact info, total jobs, and open task count. Click a host to see their profile and message them directly.",
  },
  {
    q: "I'm not receiving SMS notifications. What should I check?",
    a: "First, confirm your phone number is correct in the Profile tab. Then check Notification Preferences to ensure the relevant SMS toggles are on. If you're still not receiving them, make sure your carrier isn't blocking shortcode SMS messages, and check that PadPulse's sending number isn't blocked on your phone.",
  },
  {
    q: "Can I use the portal on my phone?",
    a: "Yes. The vendor portal is fully mobile-friendly. Just open your browser on your phone and navigate to the portal URL you were given. You don't need to install an app.",
  },
  {
    q: "What happens if I lose access or get signed out?",
    a: "Your session expires after a period of inactivity. To sign back in, visit the portal URL and enter your phone number. You'll receive a new verification code via SMS. If you no longer appear in the vendor picker after entering your number, contact the host who invited you — your account may have been deactivated.",
  },
];
